"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUniqueRelationRecordsIds = void 0;
const array_1 = require("../../helpers/array");
const getUniqueRelationRecordsIds = (value = []) => {
    const uniqueIds = [];
    for (const relation of value) {
        uniqueIds.push(relation.record);
    }
    return (0, array_1.shallowUnique)(uniqueIds);
};
exports.getUniqueRelationRecordsIds = getUniqueRelationRecordsIds;
